var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUsr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#E0EDFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#B3CEF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C15.7636 10 13.9375 11.798 13.9375 14C13.9375 16.202 15.7636 18 18 18C20.2364 18 22.0625 16.202 22.0625 14C22.0625 11.798 20.2364 10 18 10ZM13.3281 19.6C12.3257 19.6 11.5 20.413 11.5 21.4V21.8797C11.5 23.056 12.2575 24.1112 13.413 24.8367C14.5685 25.5622 16.1495 26 18 26C19.8505 26 21.4315 25.5622 22.587 24.8367C23.7425 24.1112 24.5 23.056 24.5 21.8797V21.4C24.5 20.413 23.6743 19.6 22.6719 19.6H13.3281Z",
    fill: "#006FEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsr);
export default __webpack_public_path__ + "static/media/icon-usr.e70ab048da624aca3595d08448fae29e.svg";
export { ForwardRef as ReactComponent };